import React from "react";

import { Col, Container, Form, Row } from "react-bootstrap";

import { FieldError, Resolver } from "react-hook-form";

import { Role } from "@api/graphql";
import { FormErrorText } from "@components/form/FormErrorText";
import FormNavigationButtons from "@components/form/FormNavigationButtons";
import FormsHeader from "@components/form/FormsHeader";
import FromSwitchOption from "@components/form/FromSwitchOption";

import { useRegisterForm } from "../hooks/useRegisterForm";

import { UserRoleInput, UserRoleProps, ValidationErrors } from "./RegisterFormTypes";
import { roleOptions } from "./UserRoleOptions";

export const UserRole = ({ multiFormData, onSubmit, isInsertMode = true, submitRef }: UserRoleProps) => {
  const resolver: Resolver<UserRoleInput> = async (values) => {
    const errors: ValidationErrors<UserRoleInput> = {};

    if (!values.user_role || values.user_role.length === 0) {
      errors.user_role = {
        type: "required",
        message: "At least one option must be selected",
      };
    }

    const isValid = Object.keys(errors).length === 0;

    return {
      values: isValid ? values : {},
      errors: errors,
    };
  };

  const { control, handleSubmit, watch, setValue, clearErrors, errors } = useRegisterForm<UserRoleInput>(resolver, {
    user_role: multiFormData.user_role || [],
  });

  const userRoles = watch("user_role");

  const toggleRole = (role: Role) => {
    const updatedRoles = userRoles.includes(role) ? userRoles.filter((r) => r !== role) : [...userRoles, role];
    setValue("user_role", updatedRoles);

    if (updatedRoles.length > 0) {
      clearErrors("user_role");
    }
  };

  return (
    <Form>
      <Container>
        <FormsHeader isInsertMode={isInsertMode} title="I want to" />
        <Form.Group>
          {roleOptions.map((option) => (
            <Row className="mb-4" key={option.id}>
              <FromSwitchOption
                fieldName="user_role"
                control={control}
                switchId={option.id}
                label={option.label}
                description={option.description}
                toggleSwitch={toggleRole}
                switchStates={userRoles}
                switchKey={option.roleName}
              />
            </Row>
          ))}
          <Row className="mb-4">
            <Col className="d-flex justify-content-center">
              <FormErrorText error={errors.user_role as FieldError} />
            </Col>
          </Row>
        </Form.Group>
        <FormNavigationButtons
          isInsertMode={isInsertMode}
          onSubmit={onSubmit}
          handleSubmit={handleSubmit}
          showPreviousButton={false}
          submitRef={submitRef}
        />
      </Container>
    </Form>
  );
};
